<template>
  <div class="btn-bottom-margin">
    <h1 class="header-style">
      My Projects
    </h1>
    <p class="subheader-style">
      List of all projects under this organization.
    </p>
    <organization-projects />
  </div>
</template>
<script>
  import OrganizationProjects from '../Components/dialogComponents/organizationsDialogs/OrganizationProjects.vue';
  export default {
    name: 'AppUserProjects',
    components: {
      'organization-projects': OrganizationProjects,
    },
    data: () => ({
    }),
  };
</script>
